import { Dispatch } from "react";
interface RejectCardAction {
  type: "REJECT_CARD";
  isRejected: boolean;
}
export const rejectCard =
  (isRejected: boolean) => async (dispatch: Dispatch<RejectCardAction>) => {
    dispatch({
      type: "REJECT_CARD",
      isRejected,
    });
  };
